import { gaEvent } from '.';

function initGaTracking() {
	const navigationTrackingElements = [
		{
			selector: '.c-navigation',
			action: 'Main menu',
		},
		{
			selector: '.c-navigation-sub',
			action: 'Pillar menu',
		},
		{
			selector: '.c-footer',
			action: 'Footer menu',
		}
	];

	if (navigationTrackingElements && navigationTrackingElements.length > 0) {
		navigationTrackingElements.forEach((navigationElement) => {
			const linkList = `${navigationElement.selector} a[href^="${window.location.protocol}//${window.location.host}"]`;
			document.querySelectorAll(linkList).forEach((link) => {
				link.addEventListener('click', (e) => {
					gaEvent({
						event: 'navigationInteraction',
						eventCategory: 'Navigation',
						eventAction: navigationElement.action,
						eventLabel: e.target.title,
					});
				});
			});
		});
	}

	// query and add tracking to external links
	document.querySelectorAll(`a[href]:not([href^="${window.location.protocol}//${window.location.host}"]):not([href^="#"]):not([href^="/"])`).forEach((link) => {
		link.addEventListener('click', (e) => {
			gaEvent({
				event: 'externalLink',
				eventCategory: 'External Links',
				eventAction: e.target.alt,
				eventLabel: e.target.parentElement.href,
			});
		});
	});
}

export default initGaTracking;
